<div class="ai-function-calls-container">
  <rappider-ai-crud-view [activeEntityConfig]="entityConfig"
                         [entityConfigs]="entityConfigs"
                         [displayGripButton]="false"
                         [defaultEntityNameIfNotSelected]="defaultEntityName"
                         [entityData]="entityData"
                         (entitySelected)="onEntitySelected($event)"
                         (doneClick)="onJoyrideDoneButtonClick()"
                         (entityItemSelected)="onEntityItemSelected($event)"></rappider-ai-crud-view>
</div>
